import { FC } from "react"
import { useTranslation } from "react-i18next"
import { GoogleIcon } from "@/assets"
import { getRefCode } from "@/helpers/refCode"
import type { IAuthMode } from "../types"
import styles from "./GoogleAuthButton.module.scss"

interface IGoogleAuthButton {
  mode: IAuthMode
}

export const GoogleAuthButton: FC<IGoogleAuthButton> = ({ mode }) => {
  const { t } = useTranslation()

  const handleClick = () => {
    const refCode = getRefCode()
    const refParam = refCode ? `?refCode=${refCode}` : ""
    const intent = mode === "login" ? "login" : "create"
    const link = `${import.meta.env.VITE_BACKEND}/api/auth/google/${intent}${refParam}`
    // console.log({ link })
    window.location.href = link
  }

  const i18nPrefix = mode === "login" ? "login" : "register"

  return (
    <button
      className={styles.GoogleAuthButton}
      onClick={handleClick}
      type="button"
    >
      <GoogleIcon className={styles.GoogleAuthButton_icon} />
      {t(`${i18nPrefix}.google`)}
    </button>
  )
}
